import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { PagesPageVersionsDocument, PagesPublishPageDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface PublishPageDialogProps {
  pageId: number
  folderType: string
  pageName: string
  onClose: () => void
}

export const PublishPageDialog = ({
  pageId,
  folderType,
  pageName,
  onClose,
}: PublishPageDialogProps) => {
  const [publishPage] = useMutation(PagesPublishPageDocument, {
    extractorFn: (data) => data.handbookPagesMutations.publishHandbookpagesPage,
    refetchQueries: [
      {
        query: PagesPageVersionsDocument,
        variables: {
          pageId,
        },
      },
    ],
  })

  const handleConfirmPublish = async () => {
    track(trackingEvents.pages.PagesDocumentsPublished, {
      documents_published_count: 1,
    })
    const result = await publishPage({
      variables: {
        id: pageId,
      },
    })

    const handler = handleResult(result, () => null)

    if (handler.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('pages.page.publish_page_dialog.success'),
      })
      track(trackingEvents.pages.PagesDocumentsPublishConfirmed, {
        documents_published_count: 1,
      })
      track(trackingEvents.pages.PagesPublishNewPageConfirmation, {
        folder_type: folderType,
        page_name: pageName,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.error'),
      })
    }

    onClose()
  }

  return (
    <Dialog
      onClose={onClose}
      actions={{
        primary: {
          label: i18n.t('pages.page.publish'),
          onClick: () => handleConfirmPublish(),
          variant: 'default',
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onClose,
        },
      }}
      header={{
        description: i18n.t('pages.page.publish_page_dialog.description'),
        title: i18n.t('pages.page.publish_page_dialog.title'),
        type: 'info',
      }}
      open={!!pageId}
    />
  )
}
